export default __webpack_public_path__ + "static/media/pause.b638f95c.svg";